import { useNavigate } from 'react-router-dom';
import React from 'react';
import axiosInstance from '../utils/AxiosInstance';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import useUser from './User';
import { getAgeFromDateString } from '../utils';

export const useHandleSubmitTunnel = (step, trainingId) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: user } = useUser();
  const ToastAdmin = ({ messageAdmin }) => {
    return (
      <>
        <p>Admin</p>
        <ul className={'mt-2'}>
          {messageAdmin && Array.isArray(messageAdmin) ? (
            messageAdmin.map((message) => <li>{message}</li>)
          ) : (
            <li>{messageAdmin}</li>
          )}
        </ul>
      </>
    );
  };

  return async (form) => {
    const body = { form: form, trainingId: parseInt(trainingId), step: step, type: 'cfa' };
    await axiosInstance.post('/internal_api/tunnel/handleStep', body).then((callback) => {
      const data = callback.data;
      if (data.error) {
        if (data.message) {
          toast.error(data.message);
        }
        if (data.messageAdmin) {
          toast(<ToastAdmin messageAdmin={callback.messageAdmin} />, {
            autoClose: false,
          });
        }
      } else {
        queryClient.invalidateQueries(['user']);
        queryClient.invalidateQueries(['training']);

        if (data.form.submit === 'next' || data.form.submit === 'skip') {
          switch (step) {
            case 'infosClient':
              navigate(`/inscription/eligibilite/${data.trainingId}`);
              break;
            case 'eligibilite':
              navigate(`/inscription/documents/${data.trainingId}`);
              break;
            case 'documents':
              if (user.birth_day && getAgeFromDateString(user.birth_day) < 18) {
                navigate(`/inscription/finalisation/${data.trainingId}`);
                break;
              }
              navigate(`/inscription/signature/${data.trainingId}`);
              break;
            case 'signature':
              navigate(`/inscription/finalisation/${data.trainingId}`);
              break;
            default:
              navigate(`/inscription/`);
          }
        } else {
          navigate(`/inscription/informations/${data.trainingId}`);
        }
      }
      return data;
    });
  };
};
